/*@ngInject*/
const CurrentUserProfileRepository = function (baseRepository, currentUserModel) {

    angular.extend(this, baseRepository);

    this.loadUser = function () {
        let url = '/rest/User/' + currentUserModel.getCurrentUser().userId;

        return this.get(url);
    };

};

angular.module('umCore')
    .service('currentUserProfileRepository', CurrentUserProfileRepository);
